export interface IAppNotificationGroup {
    id: number;
    groupName: string;
    groupCode: string;
    appId: string;
    /**
     * for ui rendering purposes
     */
    isOptedByUser?: boolean;
    isPartiallyOpted?: boolean;
}

export class AppNotificationGroup implements IAppNotificationGroup {
    id: number;
    groupName: string;
    groupCode: string;
    appId: string;
    isOptedByUser?: boolean;
    isPartiallyOpted?: boolean;
    constructor(data: IAppNotificationGroup) {
        this.groupCode = data.groupCode;
        this.groupName = data.groupName;
        this.id = data.id;
        this.appId = data.appId;
        if (data.isOptedByUser) {
            this.isOptedByUser = data.isOptedByUser;
        }
    }
}

